import Grid from '@mui/material/Grid';
import colors from '/@/components/theme-provider/colors';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';

const References = ({ product }) => {
    function romanize(num) {
        let lookup = {
                IV: 4,
                I: 1,
            },
            roman = '',
            i;
        for (i in lookup) {
            while (num >= lookup[i]) {
                roman += i;
                num -= lookup[i];
            }
        }
        return roman;
    }

    const references = product.references;
    const getMinAndMax = (r) => {
        if (r.max && r.min && r.min === r.max) {
            return romanize(r.min);
        }
        if (r.max === null) {
            return `>${r.min}`;
        }
        if (r.min === null) {
            return `<${r.max}`;
        }
        return `${r.min}-${r.max}`;
    };
    return (
        <Grid container sx={{ p: { md: 2 } }} direction='column'>
            <Grid item sx={{ pb: 2 }}>
                <Title size='md' color='black'>
                    {_(product.name)}
                </Title>
            </Grid>

            <Grid item>
                {references.map((r, i) => {
                    return (
                        <Grid
                            container
                            alignItems='center'
                            sx={{ width: '100%', p: 1, borderTop: '0.5px solid #E1E1E1' }}
                            xs={12}
                        >
                            <Grid item container xs={r.max && r.min && r.min === r.max ? 11 : 8}>
                                <Grid item>
                                    <div
                                        style={{
                                            borderRadius: '50%',
                                            width: '15px',
                                            height: '15px',
                                            backgroundColor:
                                                references.length === 3
                                                    ? colors.references.other[i]
                                                    : references.length === 4
                                                      ? colors.references.toxicology[i]
                                                      : colors.references.default[i],
                                        }}
                                    />
                                </Grid>
                                <Grid item sx={{ pl: 1 }}>
                                    <Title align='center' size='sm' color='black'>
                                        {_(r.value)}
                                    </Title>
                                </Grid>
                            </Grid>
                            <Grid item xs={r.max && r.min && r.min === r.max ? 1 : 4}>
                                <Title bolder align='right' size='sm' color='black'>
                                    {getMinAndMax(r)}
                                </Title>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default References;
